import React, { Fragment } from 'react';
import constants from '../../constants';
import {
    Navbar,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap'
import './Header.css'

const Header = (props) => {
    console.log(`header :: ${props.role}`);
    return (
        <div>
            <Navbar dark expand="md" className="header">
                <Nav className="container-fluid" navbar>
                    <NavItem>
                        {props.source === '*' || props.source === constants.CONVERSATION_SOURCE_GC ? (
                        <NavbarBrand href="/conversations">Recording As A Service</NavbarBrand> ) : (
                            <NavbarBrand href="/pccconversations">Recording As A Service</NavbarBrand> )}
                    </NavItem>
                    
                    <div className="d-flex flex-row-reverse">
                    {props.role === constants.USER_ROLE_ADMIN || props.source === '*' || props.source === constants.CONVERSATION_SOURCE_GC ? (
                    <NavItem className='ml-auto'>
                        <NavLink href="/conversations">Conversations</NavLink>
                    </NavItem>
                    ):(<Fragment></Fragment>)}

                    {props.role === constants.USER_ROLE_ADMIN || props.source === '*' || props.source === constants.CONVERSATION_SOURCE_ENGAGE ? (
                    <NavItem>
                        <NavLink href="/pccconversations">PCC-Conversations</NavLink>
                    </NavItem>
                    ):(<Fragment></Fragment>)}                    
                    {props.role === 'admin' ?
                        (<Fragment><UncontrolledDropdown
                            nav
                            inNavbar
                        >
                            <DropdownToggle nav caret>
                                Configuration
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem>
                                    <NavLink href="/management/users/">Users</NavLink>
                                </DropdownItem>
                                <DropdownItem>
                                    <NavLink href="/management/searchview">Search View</NavLink>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                            
                        </Fragment>)
                        : <Fragment></Fragment>}
                        
                        <Fragment>
                            {props.role === 'admin' ? (
                            <NavItem>
                                    <NavLink href="/audits/access/">Audit Reports</NavLink>
                            </NavItem>
                            ) : <Fragment></Fragment>}
                            <NavItem>
                                <NavLink href="/downloads">Downloads</NavLink>
                            </NavItem>
                        </Fragment>                         
                    </div>
                </Nav>
            </Navbar>
        </div>
    );
}

export default Header;